import { render, staticRenderFns } from "./VcNavArrow.vue?vue&type=template&id=1bb101c3&scoped=true&"
import script from "./VcNavArrow.vue?vue&type=script&lang=ts&"
export * from "./VcNavArrow.vue?vue&type=script&lang=ts&"
import style0 from "./VcNavArrow.vue?vue&type=style&index=0&id=1bb101c3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb101c3",
  null
  
)

export default component.exports